var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.517,
    height: 12.552,
    viewBox: "0 0 21.517 12.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-pl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.517,
    height: 12.552,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-pl)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.517,
    height: 4.184,
    fill: "#f4f4f4",
    stroke: "#707070",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H21.517V6.276H0Z",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.517,
    height: 6.276,
    transform: "translate(0 6.276)",
    fill: "#dc143c",
    stroke: "#707070",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/pl.ea75b621644ecfac6ef6c927e088f2cd.svg";
export { ForwardRef as ReactComponent };